export const nestedStructureTranslation = {
  buttons: {
    collapseAll: 'Zwiń wszystkie',
    expandAll: 'Rozwiń wszystkie',
  },
  children: 'Podlegli pracownicy',
  currentStructure: {
    organizational: 'Aktualna struktura organizacyjna',
    personal: 'Aktualna struktura personalna',
  },
  emptyState: {
    noData: 'Brak danych struktury',
    noDataDescription: 'Sprawdź czy dane są dostępne dla wybranej symulacji.',
    selectDescription:
      'Przejdź do zakładki "Zarządzaj strukturami" aby wyświetlić i wybrać strukturę.',
    selectStructure: 'Wybierz strukturę',
  },
  goToProfile: 'Przejdź do profilu',
  hierarchy: 'Hierarchia',
  loading: 'Ładowanie struktury...',
  noHierarchyInfo: 'Brak informacji o hierarchii',
  search: {
    label: 'Wyszukiwanie:',
    placeholder: 'Szukaj...',
  },
  statistics: {
    expandedNodes: 'Rozwinięte węzły:',
    totalUnits: 'Łączna liczba jednostek:',
  },
  structureType: {
    organizational: 'Organizacyjna',
    personal: 'Personalna',
  },
  subunits: 'podjednostek',
  title: 'Struktura zagnieżdżona',
  total: 'łącznie',
  type: 'Typ',
  unitName: 'Nazwa jednostki',
  vacancy: 'WAKAT',
  viewMode: {
    cards: 'Pełny',
    tree: 'Kompaktowy',
  },
};
